/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import SwiperCore, { Mousewheel, Pagination } from 'swiper';
import Badge from 'components/atoms/badge';
import { ISKillsObject } from 'types/ISkill';
import SectionWithSwiper from 'components/organisms/section/sectionWithSwiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { ADVANCED_SKILLS, BASIC_SKILLS } from './constants/ConstSkills';

SwiperCore.use([Pagination, Mousewheel]);

enum AvailableTabs {
  BASIC = 'Basic Skills',
  ADVANCED = 'Advanced Skills',
}

export default function Skills() {
  const renderSkills = (SKILLS: ISKillsObject) => {
    const SKILLS_CATEGORIES = Object.keys(SKILLS);
    const [currentCategory, setCurrentCategory] = useState(SKILLS_CATEGORIES[0]);

    const determineCurrentCategory = (index: number) => {
      setCurrentCategory(SKILLS_CATEGORIES[index]);
    };

    return (
      <SectionWithSwiper
        styles="mt-0"
        title={currentCategory}
        slidesPerView={1}
        slidesPerGroup={1}
        direction="vertical"
        mousewheel={{ forceToAxis: true, thresholdDelta: 50 }}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Mousewheel]}
        onSlideChange={swiper => {
          determineCurrentCategory(swiper.activeIndex);
        }}>
        {SKILLS_CATEGORIES.map(category => (
          <SwiperSlide key={category} className="px-8 grid gap-x-8 items-center grid-cols-1 sm:grid-cols-2">
            {SKILLS[category as keyof ISKillsObject]?.map(skill => {
              const yearsOfExperience = skill?.yearsOfExperience;
              return (
                <Accordion key={skill?.name} type="single" collapsible>
                  <AccordionItem value={skill?.name} className="border-b-2 border-b-[rgba(255,255,255,0.15)]">
                    <AccordionTrigger>
                      <div className="w-full flex items-center gap-1 sm:gap-2">
                        <img src={skill?.image} className="h-7 w-7 sm:h-12 sm:w-12" alt="Icon of skill" />
                        <div>
                          <div className="my-auto text-lg sm:text-2xl">{skill.name}</div>
                        </div>
                        {yearsOfExperience && (
                          <Badge
                            styles="my-auto ml-2 cursor-pointer"
                            text={`${yearsOfExperience.toString()} YEAR${yearsOfExperience > 1 ? 'S' : ''}`}
                          />
                        )}
                      </div>
                    </AccordionTrigger>
                    <AccordionContent>{skill?.description}</AccordionContent>
                  </AccordionItem>
                </Accordion>
              );
            })}
          </SwiperSlide>
        ))}
      </SectionWithSwiper>
    );
  };

  return (
    <div className="h-5/6 sm:h-4/6 w-full">
      <Tabs className="h-full w-full" defaultValue={AvailableTabs?.BASIC}>
        <TabsList className="w-full">
          <TabsTrigger className="w-full" value={AvailableTabs?.BASIC}>
            Basic Skills
          </TabsTrigger>
          <TabsTrigger className="w-full" value={AvailableTabs?.ADVANCED}>
            Advanced Skills
          </TabsTrigger>
        </TabsList>
        <TabsContent className="h-full w-full" value={AvailableTabs?.BASIC}>
          {renderSkills(BASIC_SKILLS)}
        </TabsContent>
        <TabsContent className="h-full w-full" value={AvailableTabs?.ADVANCED}>
          {renderSkills(ADVANCED_SKILLS)}
        </TabsContent>
      </Tabs>
    </div>
  );
}
